import type { PAGE_POSITIONS } from 'types';
import type { AffiliateStockListing, CapiProductPage } from 'types/capi/pdp';

import HiddenIcon from '~/assets/icons/Hidden';
import DiscountCode from '~/components/DiscountCode';
import usePageData from '~/hooks/usePageData';
import { getStockStatusForSize } from '~/utils/listings';

import Buttons from '../../components/Buttons';
import AffiliateSizes from './AffiliateSizes';
import ShippingAndPrice from './ShippingAndPrice';
import { StockStatus } from './StockListing';

type Props = {
  listing: AffiliateStockListing;
  pagePosition: PAGE_POSITIONS;
  position: number;
  selectedSize?: string;
};

export default function StockListingGated({
  listing,
  position,
  selectedSize,
  pagePosition
}: Props) {
  const product = usePageData<CapiProductPage>();

  const stockStatus = getStockStatusForSize(listing, selectedSize);

  return (
    <div className="flex flex-col gap-4 rounded-lg bg-white p-4">
      <div className="flex gap-4 bg-white">
        <div className="flex grow items-center gap-4">
          <div className="rounded-lg bg-grey-tile p-2">
            <HiddenIcon />
          </div>
          <div>
            <StockStatus
              stockStatus={stockStatus}
              listing={listing}
              selectedSize={selectedSize}
            />
          </div>
        </div>
        <ShippingAndPrice listing={listing} selectedSize={selectedSize} />
      </div>
      <AffiliateSizes
        product={product}
        price={listing.price}
        affiliate={listing.affiliate}
        selectedSize={selectedSize}
        sizes={listing.sizes}
        disableClickThrough
        urlTemplates={listing}
        position={position}
        pagePosition={pagePosition}
      />
      <div className="flex w-full flex-col gap-2">
        <DiscountCode
          code={listing.discount_code?.code}
          amount={listing.discount_code?.amount}
        />
        <Buttons.Gated pagePosition={pagePosition} />
      </div>
    </div>
  );
}
